import update from 'immutability-helper'

import { deleteItemById, updateItem } from '../../helpers/modules/reducerHelpers'

import {
  INITIAL_CREATE_REDUCER,
  INITIAL_UPDATE_REDUCER,
  INITIAL_DELETE_REDUCER,
  INITIAL_GET_REDUCER,
  INITIAL_GET_RESULTS_PAGING_REDUCER,
  INITIAL_GET_RESULTS_REDUCER
} from '../../constants/reducer'
import {
  GET_BOOKING_MEDIA_FILES,
  GET_BOOKING_MEDIA_FILES_SUCCESS,
  GET_BOOKING_MEDIA_FILES_FAILURE,
  CLEAR_GET_BOOKING_MEDIA_FILES,
  CLEAR_GET_ORDER_BOOKED_MEDIA,
  GET_ORDER_BOOKED_MEDIA,
  GET_ORDER_BOOKED_MEDIA_FAILURE,
  GET_ORDER_BOOKED_MEDIA_SUCCESS,
  UPLOAD_BOOKING_MEDIA_FILE,
  UPLOAD_BOOKING_MEDIA_FILE_SUCCESS,
  UPLOAD_BOOKING_MEDIA_FILE_FAILURE,
  CLEAR_UPLOAD_BOOKING_MEDIA_FILE,
  DELETE_BOOKING_MEDIA_FILE,
  DELETE_BOOKING_MEDIA_FILE_SUCCESS,
  DELETE_BOOKING_MEDIA_FILE_FAILURE,
  CLEAR_DELETE_BOOKING_MEDIA_FILE,
  UPDATE_BOOKING_MEDIA_FILE,
  UPDATE_BOOKING_MEDIA_FILE_FAILURE,
  CLEAR_UPDATE_BOOKING_MEDIA_FILE,
  UPDATE_BOOKING_MEDIA_FILE_SUCCESS,
  GET_MEDIA_ORDERS_BOOKINGS_AS_CSV,
  GET_MEDIA_ORDERS_BOOKINGS_AS_CSV_FAILURE,
  GET_MEDIA_ORDERS_BOOKINGS_AS_CSV_SUCCESS,
  CLEAR_GET_MEDIA_ORDERS_BOOKINGS_AS_CSV,
  GET_BOOKED_MEDIA_REPORT,
  GET_BOOKED_MEDIA_REPORT_SUCCESS,
  GET_BOOKED_MEDIA_REPORT_FAILURE,
  CLEAR_GET_BOOKED_MEDIA_REPORT,
  GET_INSTALLATION_BOOKED_MEDIA_REPORT,
  GET_INSTALLATION_BOOKED_MEDIA_REPORT_SUCCESS,
  GET_INSTALLATION_BOOKED_MEDIA_REPORT_FAILURE,
  CLEAR_GET_INSTALLATION_BOOKED_MEDIA_REPORT,
  GET_INSTALLATION_BOOKED_MEDIA_REPORT_AS_CSV,
  GET_INSTALLATION_BOOKED_MEDIA_REPORT_AS_CSV_SUCCESS,
  GET_INSTALLATION_BOOKED_MEDIA_REPORT_AS_CSV_FAILURE,
  CLEAR_GET_INSTALLATION_BOOKED_MEDIA_REPORT_AS_CSV,
  BULK_UPDATE_BOOKING_MEDIA_FILE,
  BULK_UPDATE_BOOKING_MEDIA_FILE_SUCCESS,
  BULK_UPDATE_BOOKING_MEDIA_FILE_FAILURE,
  CLEAR_BULK_UPDATE_BOOKING_MEDIA_FILE,
  BULK_UPDATE_BOOKED_MEDIA,
  BULK_UPDATE_BOOKED_MEDIA_SUCCESS,
  BULK_UPDATE_BOOKED_MEDIA_FAILURE,
  CLEAR_BULK_UPDATE_BOOKED_MEDIA,
  GET_BOOKED_MEDIA,
  GET_BOOKED_MEDIA_SUCCESS,
  GET_BOOKED_MEDIA_FAILURE,
  CLEAR_GET_BOOKED_MEDIA,
  GET_BOOKED_REVENUE_REPORT,
  GET_BOOKED_REVENUE_REPORT_SUCCESS,
  GET_BOOKED_REVENUE_REPORT_FAILURE,
  CLEAR_GET_BOOKED_REVENUE_REPORT,
  GET_BRAND_REVENUE_REPORT,
  GET_BRAND_REVENUE_REPORT_SUCCESS,
  GET_BRAND_REVENUE_REPORT_FAILURE,
  CLEAR_GET_BRAND_REVENUE_REPORT,
  GET_UPLOADED_FILES_PENDING_APPROVAL_COUNT,
  GET_UPLOADED_FILES_PENDING_APPROVAL_COUNT_SUCCESS,
  GET_UPLOADED_FILES_PENDING_APPROVAL_COUNT_FAILURE,
  CLEAR_GET_UPLOADED_FILES_PENDING_APPROVAL_COUNT,
  GET_BOOKING_VARIABLES,
  GET_BOOKING_VARIABLES_SUCCESS,
  GET_BOOKING_VARIABLES_FAILURE,
  CLEAR_GET_BOOKING_VARIABLES,
  CREATE_BOOKING_VARIABLE,
  CREATE_BOOKING_VARIABLE_SUCCESS,
  CREATE_BOOKING_VARIABLE_FAILURE,
  CLEAR_CREATE_BOOKING_VARIABLE,
  UPDATE_BOOKING_VARIABLE,
  UPDATE_BOOKING_VARIABLE_SUCCESS,
  UPDATE_BOOKING_VARIABLE_FAILURE,
  CLEAR_UPDATE_BOOKING_VARIABLE,
  GET_BOOKING_VARIABLE,
  GET_BOOKING_VARIABLE_SUCCESS,
  GET_BOOKING_VARIABLE_FAILURE,
  CLEAR_GET_BOOKING_VARIABLE,
  GET_BOOKING_VARIABLE_OPTIONS,
  GET_BOOKING_VARIABLE_OPTIONS_SUCCESS,
  GET_BOOKING_VARIABLE_OPTIONS_FAILURE,
  CLEAR_GET_BOOKING_VARIABLE_OPTIONS,
  GENERATE_CAMPAIGN_REACH_REPORT,
  GENERATE_CAMPAIGN_REACH_REPORT_SUCCESS,
  GENERATE_CAMPAIGN_REACH_REPORT_FAILURE,
  CLEAR_GENERATE_CAMPAIGN_REACH_REPORT,
  SEND_CAMPAIGN_REACH_REPORT,
  SEND_CAMPAIGN_REACH_REPORT_SUCCESS,
  SEND_CAMPAIGN_REACH_REPORT_FAILURE,
  CLEAR_SEND_CAMPAIGN_REACH_REPORT,
  UPDATE_BOOKED_MEDIA,
  UPDATE_BOOKED_MEDIA_SUCCESS,
  UPDATE_BOOKED_MEDIA_FAILURE,
  CLEAR_UPDATE_BOOKED_MEDIA,
  GET_MEDIA_ORDER_REQUESTED_FILES,
  GET_MEDIA_ORDER_REQUESTED_FILES_SUCCESS,
  GET_MEDIA_ORDER_REQUESTED_FILES_FAILURE,
  CLEAR_GET_MEDIA_ORDER_REQUESTED_FILES
} from '../actions/mediaOrdersBookings'
import {
  mergeBookedMediaReportProductsNextPrev,
  updateBookedMediaUploadedFilesComments
} from '../../helpers/modules/reducerHelpers/mediaOrdersBookings'

const initialState = {
  // PLOP_APPEND_PATTERN_ANCHOR_INITIAL_REDUCER
  bookingVariableOptions: INITIAL_GET_RESULTS_PAGING_REDUCER,
  bookedMedia: INITIAL_GET_RESULTS_PAGING_REDUCER,
  bookedMediaReport: {
    ...INITIAL_GET_RESULTS_REDUCER,
    loadingPeriods: []
  },
  bookingMediaFiles: INITIAL_GET_RESULTS_PAGING_REDUCER,
  bookingVariables: INITIAL_GET_RESULTS_PAGING_REDUCER,
  brandRevenueReport: INITIAL_GET_RESULTS_REDUCER,
  bulkUpdateBookedMedia: INITIAL_UPDATE_REDUCER,
  bulkUpdateBookingMediaFile: INITIAL_UPDATE_REDUCER,
  createBookingVariable: INITIAL_CREATE_REDUCER,
  deleteBookingMediaFile: INITIAL_DELETE_REDUCER,
  getBookedMedia: INITIAL_GET_REDUCER,
  getBookedRevenueReport: {
    ...INITIAL_GET_RESULTS_REDUCER,
    loadingPeriods: []
  },
  getBookingVariable: INITIAL_GET_REDUCER,
  generateCampaignReachReport: INITIAL_CREATE_REDUCER,
  installationBookedMediaReport: INITIAL_GET_RESULTS_REDUCER,
  installationBookedMediaReportAsCSV: INITIAL_GET_REDUCER,
  mediaOrderRequestedFiles: INITIAL_GET_RESULTS_REDUCER,
  mediaOrdersBookingsAsCSV: INITIAL_GET_REDUCER,
  sendCampaignReachReport: INITIAL_CREATE_REDUCER,
  updateBookedMedia: INITIAL_UPDATE_REDUCER,
  updateBookingMediaFile: INITIAL_UPDATE_REDUCER,
  updateBookingVariable: INITIAL_UPDATE_REDUCER,
  uploadBookingMediaFile: INITIAL_CREATE_REDUCER,
  uploadedFilesPendingApprovalCount: INITIAL_GET_REDUCER
}

export default function mediaOrdersBookings(state = initialState, action) {
  const bookedMediaWasLoaded = state.bookedMedia.wasLoaded
  const requestedFilesWasLoaded = state.mediaOrderRequestedFiles.wasLoaded

  switch (action.type) {
    // PLOP_APPEND_PATTERN_ANCHOR_REDUCERS

    // Get media orders bookings as csv
    case GET_MEDIA_ORDERS_BOOKINGS_AS_CSV:
      return update(state, {
        mediaOrdersBookingsAsCSV: { $merge: { isLoading: true } }
      })
    case GET_MEDIA_ORDERS_BOOKINGS_AS_CSV_SUCCESS:
      return update(state, {
        mediaOrdersBookingsAsCSV: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            data: action.data
          }
        }
      })
    case GET_MEDIA_ORDERS_BOOKINGS_AS_CSV_FAILURE:
      return update(state, {
        mediaOrdersBookingsAsCSV: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_MEDIA_ORDERS_BOOKINGS_AS_CSV:
      return update(state, {
        mediaOrdersBookingsAsCSV: { $set: initialState.mediaOrdersBookingsAsCSV }
      })

    // Get booking media files
    case GET_BOOKING_MEDIA_FILES:
      return update(state, {
        bookingMediaFiles: { $merge: { isLoading: true } }
      })
    case GET_BOOKING_MEDIA_FILES_SUCCESS:
      return update(state, {
        bookingMediaFiles: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            paging: {
              next: action.data?.next
            }
          },
          results: {
            $push: action.data.results
          }
        }
      })
    case GET_BOOKING_MEDIA_FILES_FAILURE:
      return update(state, {
        bookingMediaFiles: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_BOOKING_MEDIA_FILES:
      return update(state, {
        bookingMediaFiles: { $set: initialState.bookingMediaFiles }
      })

    // Upload booking media file
    case UPLOAD_BOOKING_MEDIA_FILE:
      return update(state, {
        uploadBookingMediaFile: { $merge: { isLoading: true, requestedFileId: action.data?.[0]?.media_product_file } }
      })
    case UPLOAD_BOOKING_MEDIA_FILE_SUCCESS:
      return update(state, {
        uploadBookingMediaFile: {
          $merge: {
            isLoading: false,
            wasCreated: true,
            data: action.data
          }
        },
        bookedMedia: {
          results: {
            $apply: items => {
              if (bookedMediaWasLoaded) {
                // Add uploaded file to the booked medias
                // one file could be added to multiple medias so need to loop through all of them and call updateItem
                // to each booked media which is updated
                return action.data.reduce((bookedMedias, file) => {
                  // find data through the updated bookedMedia to avoid losing previous updates:
                  // for cases when media have multiple files, and multiple files where uploaded for it
                  const oldMedia = bookedMedias.find(item => item.id === file.booked_media)
                  const updatedMedia = {
                    ...oldMedia,
                    // add the new file to already uploaded files
                    uploaded_files: [...oldMedia?.uploaded_files, file]
                  }

                  return updateItem(bookedMedias, updatedMedia, file.booked_media)
                }, items)
              } else {
                // if booked media was not loaded, just return the items
                return items
              }
            }
          }
        },
        mediaOrderRequestedFiles: {
          results: {
            // Add newly uploaded file to requested_file field: uploaded_files
            // one file could be added to multiple booked_media so in response we get the array of uploaded files
            // then need to loop through each and push it to requested file which has the same booked_media_id and requested file id
            $apply: items => {
              if (requestedFilesWasLoaded) {
                const newUploadedFiles = action.data

                return newUploadedFiles.reduce((requestedFiles, uploadedFile) => {
                  const oldFile = requestedFiles.find(file => {
                    // one requested file could be in multiple booked media
                    // so check the booked media and file id to update the exact file
                    const isSameBookedMedia = file.booked_media.id === uploadedFile.booked_media
                    const isSameRequestedFile = file.requested_file.id === uploadedFile.media_product_file
                    // when the file request is from custom date check if the custom date is the same
                    const isTheSameCustomDate = file.requested_file.custom_date
                      ? file.requested_file.date_start === uploadedFile.custom_booking_date
                      : true

                    return isSameBookedMedia && isSameRequestedFile && isTheSameCustomDate
                  })
                  const updatedFile = {
                    ...oldFile,
                    // add the new file to already uploaded files
                    uploaded_files: [...oldFile?.uploaded_files, uploadedFile]
                  }

                  return updateItem(requestedFiles, updatedFile, oldFile.id)
                }, items)
              } else {
                // if requested files was not loaded, just return the items
                return items
              }
            }
          }
        }
      })
    case UPLOAD_BOOKING_MEDIA_FILE_FAILURE:
      return update(state, {
        uploadBookingMediaFile: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_UPLOAD_BOOKING_MEDIA_FILE:
      return update(state, {
        uploadBookingMediaFile: { $set: initialState.uploadBookingMediaFile }
      })

    // Update booking media file
    case UPDATE_BOOKING_MEDIA_FILE:
      return update(state, {
        updateBookingMediaFile: {
          $merge: {
            isLoading: true,
            id: action.id,
            requestedFileId: action?.data?.requestedFileId,
            booked_media: action?.data?.booked_media
          }
        }
      })
    case UPDATE_BOOKING_MEDIA_FILE_SUCCESS:
      return update(state, {
        updateBookingMediaFile: {
          $merge: {
            isLoading: false,
            wasUpdated: true,
            data: action.data
          }
        },
        bookedMedia: {
          results: {
            $apply: items => {
              const oldMedia = items.find(item => item.id === action.data.booked_media)
              const updatedMedia = {
                ...oldMedia,
                uploaded_files: updateItem(oldMedia.uploaded_files, action.data, action.data.id)
              }

              return updateItem(items, updatedMedia, action.data.booked_media)
            }
          }
        }
      })
    case UPDATE_BOOKING_MEDIA_FILE_FAILURE:
      return update(state, {
        updateBookingMediaFile: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_UPDATE_BOOKING_MEDIA_FILE:
      return update(state, {
        updateBookingMediaFile: { $set: initialState.updateBookingMediaFile }
      })

    // Delete booking media file
    case DELETE_BOOKING_MEDIA_FILE:
      return update(state, {
        deleteBookingMediaFile: {
          $merge: {
            isLoading: true,
            id: action.id,
            requestedFileRowId: action?.requestedFileRowId,
            booked_media: action?.params?.booked_media
          }
        }
      })
    case DELETE_BOOKING_MEDIA_FILE_SUCCESS:
      return update(state, {
        deleteBookingMediaFile: {
          $merge: {
            isLoading: false,
            wasDeleted: true
          }
        },
        bookedMedia: {
          results: {
            $apply: items => {
              if (bookedMediaWasLoaded) {
                const oldMedia = items.find(item => item.id === action.data.booked_media)
                const updatedMedia = {
                  ...oldMedia,
                  uploaded_files: deleteItemById(oldMedia?.uploaded_files, action.data.id)
                }

                return updateItem(items, updatedMedia, action.data.booked_media)
              } else {
                return items
              }
            }
          }
        },
        mediaOrderRequestedFiles: {
          results: {
            $apply: files => {
              if (requestedFilesWasLoaded) {
                return (
                  files
                    .map(file =>
                      file.id === action?.requestedFileRowId
                        ? {
                            ...file,
                            uploaded_files: deleteItemById(file?.uploaded_files, action.data.id)
                          }
                        : file
                    )
                    // when the floating file is deleted, remove the request from the list, as it's not valid anymore
                    .filter(file => !(file.requested_file.note_code && file.uploaded_files.length === 0))
                )
              } else {
                return files
              }
            }
          }
        }
      })
    case DELETE_BOOKING_MEDIA_FILE_FAILURE:
      return update(state, {
        deleteBookingMediaFile: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_DELETE_BOOKING_MEDIA_FILE:
      return update(state, {
        deleteBookingMediaFile: { $set: initialState.deleteBookingMediaFile }
      })

    // Get order booked media
    case GET_ORDER_BOOKED_MEDIA:
      return update(state, {
        bookedMedia: {
          $merge: {
            ...(action.loadOptions.shouldClearExistingState && INITIAL_GET_RESULTS_PAGING_REDUCER),
            isLoading: true
          }
        }
      })
    case GET_ORDER_BOOKED_MEDIA_SUCCESS:
      return update(state, {
        bookedMedia: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            paging: {
              next: action.data?.next
            }
          },
          results: {
            $push: action.data.results
          }
        }
      })
    case GET_ORDER_BOOKED_MEDIA_FAILURE:
      return update(state, {
        bookedMedia: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_ORDER_BOOKED_MEDIA:
      return update(state, {
        bookedMedia: { $set: initialState.bookedMedia }
      })

    // Get booked media report
    case GET_BOOKED_MEDIA_REPORT:
      return update(state, {
        bookedMediaReport: {
          $merge: {
            ...(action.loadOptions.shouldClearExistingState && INITIAL_GET_RESULTS_REDUCER),
            isLoading: true
          },
          ...(action.period && {
            loadingPeriods: {
              $push: [action.period]
            }
          })
        }
      })
    case GET_BOOKED_MEDIA_REPORT_SUCCESS:
      return update(state, {
        bookedMediaReport: {
          $merge: {
            isLoading: false,
            wasLoaded: true
          },
          results: {
            $apply: oldData => {
              // Loop through the new array of data
              return action.data.reduce((updatedData, newLocationItem) => {
                // Find the index of the new location group item in the old data
                const index = updatedData.findIndex(oldItem => oldItem.location_name === newLocationItem.location_name)
                const isExistingLocationGroup = index >= 0

                // If the new item exists in the old data, update it
                // Otherwise, add it to the old data
                return isExistingLocationGroup
                  ? update(updatedData, {
                      [index]: {
                        $merge: {
                          ...newLocationItem,
                          // Merge products by appending booked_media and quotations
                          products: mergeBookedMediaReportProductsNextPrev(
                            newLocationItem.products,
                            updatedData[index].products
                          )
                        }
                      }
                    })
                  : [...updatedData, newLocationItem]
              }, oldData)
            }
          },
          // remove loaded periods:
          ...(action.period && {
            loadingPeriods: {
              $apply: periods => periods.filter(period => period.startDate !== action.period.startDate)
            }
          })
        }
      })
    case GET_BOOKED_MEDIA_REPORT_FAILURE:
      return update(state, {
        bookedMediaReport: {
          $merge: {
            isLoading: false,
            error: action.error
          },
          // remove period from loading:
          ...(action.period && {
            loadingPeriods: {
              $apply: periods => periods.filter(period => period.startDate !== action.period.startDate)
            }
          })
        }
      })
    case CLEAR_GET_BOOKED_MEDIA_REPORT:
      return update(state, {
        bookedMediaReport: { $set: initialState.bookedMediaReport }
      })

    // Get booked revenue report
    case GET_BOOKED_REVENUE_REPORT:
      return update(state, {
        getBookedRevenueReport: {
          $merge: {
            ...(action.loadOptions.shouldClearExistingState && INITIAL_GET_RESULTS_REDUCER),
            isLoading: true
          },
          ...(action.period && {
            loadingPeriods: {
              $push: [action.period]
            }
          })
        }
      })
    case GET_BOOKED_REVENUE_REPORT_SUCCESS:
      return update(state, {
        getBookedRevenueReport: {
          $merge: {
            isLoading: false,
            wasLoaded: true
          },
          results: {
            $apply: oldData => {
              // Loop through the new array of data
              return action.data.reduce((updatedData, newItem) => {
                // Find the index of the new item in the old data
                const index = updatedData.findIndex(oldItem => oldItem.breakdown_item === newItem.breakdown_item)

                // If the new item exists in the old data, update it
                // Otherwise, add it to the old data
                return index >= 0
                  ? update(updatedData, {
                      [index]: {
                        $merge: {
                          ...newItem,
                          // push new booked media to the previous
                          items: [...updatedData[index].items, ...newItem.items]
                        }
                      }
                    })
                  : [...updatedData, newItem]
              }, oldData)
            }
          },
          // remove loaded periods:
          ...(action.period && {
            loadingPeriods: {
              $apply: periods => periods.filter(period => period.startDate !== action.period.startDate)
            }
          })
        }
      })
    case GET_BOOKED_REVENUE_REPORT_FAILURE:
      return update(state, {
        getBookedRevenueReport: {
          $merge: {
            isLoading: false,
            error: action.error
          },
          // remove period from loading:
          ...(action.period && {
            loadingPeriods: {
              $apply: periods => periods.filter(period => period.startDate !== action.period.startDate)
            }
          })
        }
      })
    case CLEAR_GET_BOOKED_REVENUE_REPORT:
      return update(state, {
        getBookedRevenueReport: { $set: initialState.getBookedRevenueReport }
      })

    // Get installation booked media report
    case GET_INSTALLATION_BOOKED_MEDIA_REPORT:
      return update(state, {
        installationBookedMediaReport: { $merge: { isLoading: true } }
      })
    case GET_INSTALLATION_BOOKED_MEDIA_REPORT_SUCCESS:
      return update(state, {
        installationBookedMediaReport: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.data
          }
        }
      })
    case GET_INSTALLATION_BOOKED_MEDIA_REPORT_FAILURE:
      return update(state, {
        installationBookedMediaReport: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_INSTALLATION_BOOKED_MEDIA_REPORT:
      return update(state, {
        installationBookedMediaReport: { $set: initialState.installationBookedMediaReport }
      })

    // get installation booked media report as csv
    case GET_INSTALLATION_BOOKED_MEDIA_REPORT_AS_CSV:
      return update(state, {
        installationBookedMediaReportAsCSV: { $merge: { isLoading: true } }
      })
    case GET_INSTALLATION_BOOKED_MEDIA_REPORT_AS_CSV_SUCCESS:
      return update(state, {
        installationBookedMediaReportAsCSV: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            data: action.data,
            fileName: action.fileName
          }
        }
      })
    case GET_INSTALLATION_BOOKED_MEDIA_REPORT_AS_CSV_FAILURE:
      return update(state, {
        installationBookedMediaReportAsCSV: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_INSTALLATION_BOOKED_MEDIA_REPORT_AS_CSV:
      return update(state, {
        installationBookedMediaReportAsCSV: { $set: initialState.installationBookedMediaReportAsCSV }
      })

    // Bulk update booking media file
    case BULK_UPDATE_BOOKING_MEDIA_FILE:
      return update(state, {
        bulkUpdateBookingMediaFile: {
          $merge: {
            isLoading: true,
            ids: action.data?.ids,
            sequentialIds: action.data?.sequentialIds,
            booked_media: action?.data?.booked_media
          }
        }
      })
    case BULK_UPDATE_BOOKING_MEDIA_FILE_SUCCESS:
      return update(state, {
        bulkUpdateBookingMediaFile: {
          $merge: {
            isLoading: false,
            wasUpdated: true,
            data: action.data
          }
        },
        bookedMedia: {
          results: {
            // updateBookedMediaUploadedFilesComments if bookedMedia was loaded
            $apply: items => (bookedMediaWasLoaded ? updateBookedMediaUploadedFilesComments(items, action) : [])
          }
        },
        mediaOrderRequestedFiles: {
          results: {
            // updated uploaded files fot requested files,
            $apply: requestedFiles =>
              requestedFilesWasLoaded ? updateBookedMediaUploadedFilesComments(requestedFiles, action) : []
          }
        }
      })
    case BULK_UPDATE_BOOKING_MEDIA_FILE_FAILURE:
      return update(state, {
        bulkUpdateBookingMediaFile: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_BULK_UPDATE_BOOKING_MEDIA_FILE:
      return update(state, {
        bulkUpdateBookingMediaFile: { $set: initialState.bulkUpdateBookingMediaFile }
      })

    // Update booked media
    case UPDATE_BOOKED_MEDIA:
      return update(state, {
        updateBookedMedia: {
          $merge: {
            isLoading: true,
            id: action.id
          }
        }
      })
    case UPDATE_BOOKED_MEDIA_SUCCESS:
      return update(state, {
        updateBookedMedia: {
          $merge: {
            isLoading: false,
            wasUpdated: true,
            data: action.data
          }
        },
        bookedMedia: {
          results: {
            $apply: items => {
              return updateItem(items, action.data)
            }
          }
        }
      })
    case UPDATE_BOOKED_MEDIA_FAILURE:
      return update(state, {
        updateBookedMedia: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_UPDATE_BOOKED_MEDIA:
      return update(state, {
        updateBookedMedia: { $set: initialState.updateBookedMedia }
      })

    // Bulk update booked media
    case BULK_UPDATE_BOOKED_MEDIA:
      return update(state, {
        bulkUpdateBookedMedia: { $merge: { isLoading: true, ids: action.data.ids } }
      })
    case BULK_UPDATE_BOOKED_MEDIA_SUCCESS:
      return update(state, {
        bulkUpdateBookedMedia: {
          $merge: {
            isLoading: false,
            wasUpdated: true,
            data: action.data
          }
        }
      })
    case BULK_UPDATE_BOOKED_MEDIA_FAILURE:
      return update(state, {
        bulkUpdateBookedMedia: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_BULK_UPDATE_BOOKED_MEDIA:
      return update(state, {
        bulkUpdateBookedMedia: { $set: initialState.bulkUpdateBookedMedia }
      })

    // Get booked media
    case GET_BOOKED_MEDIA:
      return update(state, {
        getBookedMedia: { $merge: { isLoading: true } }
      })
    case GET_BOOKED_MEDIA_SUCCESS:
      return update(state, {
        getBookedMedia: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            data: action.data
          }
        }
      })
    case GET_BOOKED_MEDIA_FAILURE:
      return update(state, {
        getBookedMedia: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_BOOKED_MEDIA:
      return update(state, {
        getBookedMedia: { $set: initialState.getBookedMedia }
      })

    // Get brand revenue report
    case GET_BRAND_REVENUE_REPORT:
      return update(state, {
        brandRevenueReport: { $merge: { isLoading: true } }
      })
    case GET_BRAND_REVENUE_REPORT_SUCCESS:
      return update(state, {
        brandRevenueReport: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            data: action.data
          }
        }
      })
    case GET_BRAND_REVENUE_REPORT_FAILURE:
      return update(state, {
        brandRevenueReport: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_BRAND_REVENUE_REPORT:
      return update(state, {
        brandRevenueReport: { $set: initialState.brandRevenueReport }
      })

    // Get uploaded files pending approval items count
    case GET_UPLOADED_FILES_PENDING_APPROVAL_COUNT:
      return update(state, {
        uploadedFilesPendingApprovalCount: { $merge: { isLoading: true } }
      })
    case GET_UPLOADED_FILES_PENDING_APPROVAL_COUNT_SUCCESS:
      return update(state, {
        uploadedFilesPendingApprovalCount: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            data: action.data
          }
        }
      })
    case GET_UPLOADED_FILES_PENDING_APPROVAL_COUNT_FAILURE:
      return update(state, {
        uploadedFilesPendingApprovalCount: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_UPLOADED_FILES_PENDING_APPROVAL_COUNT:
      return update(state, {
        uploadedFilesPendingApprovalCount: { $set: initialState.uploadedFilesPendingApprovalCount }
      })

    // Get booking variables
    case GET_BOOKING_VARIABLES:
      return update(state, {
        bookingVariables: { $merge: { isLoading: true } }
      })

    case GET_BOOKING_VARIABLES_SUCCESS:
      return update(state, {
        bookingVariables: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            paging: {
              next: action.data?.next
            }
          },
          results: {
            $push: action.data
          }
        }
      })
    case GET_BOOKING_VARIABLES_FAILURE:
      return update(state, {
        bookingVariables: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_BOOKING_VARIABLES:
      return update(state, {
        bookingVariables: { $set: initialState.bookingVariables }
      })

    // Create booking variable
    case CREATE_BOOKING_VARIABLE:
      return update(state, {
        createBookingVariable: { $merge: { isLoading: true } }
      })
    case CREATE_BOOKING_VARIABLE_SUCCESS:
      return update(state, {
        createBookingVariable: {
          $merge: {
            isLoading: false,
            wasCreated: true,
            data: action.data
          }
        },
        bookingVariables: {
          results: {
            $push: [action.data]
          }
        }
      })
    case CREATE_BOOKING_VARIABLE_FAILURE:
      return update(state, {
        createBookingVariable: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_CREATE_BOOKING_VARIABLE:
      return update(state, {
        createBookingVariable: { $set: initialState.createBookingVariable }
      })

    // Get booking variable
    case GET_BOOKING_VARIABLE:
      return update(state, {
        getBookingVariable: { $merge: { isLoading: true } }
      })
    case GET_BOOKING_VARIABLE_SUCCESS:
      return update(state, {
        getBookingVariable: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            data: action.data
          }
        }
      })
    case GET_BOOKING_VARIABLE_FAILURE:
      return update(state, {
        getBookingVariable: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_BOOKING_VARIABLE:
      return update(state, {
        getBookingVariable: { $set: initialState.getBookingVariable }
      })

    // Update booking variable
    case UPDATE_BOOKING_VARIABLE:
      return update(state, {
        updateBookingVariable: {
          $merge: {
            isLoading: true,
            id: action.id,
            data: action.data
          }
        }
      })
    case UPDATE_BOOKING_VARIABLE_SUCCESS:
      return update(state, {
        updateBookingVariable: {
          $merge: {
            isLoading: false,
            wasUpdated: true
          }
        },
        bookingVariables: {
          results: {
            $apply: items => {
              // If user deleted the variable, we actually change status to deleted,
              // and remove it from the list
              if (action.data.status === 'deleted') {
                return deleteItemById(items, action.data.id)
              } else {
                return updateItem(items, action.data)
              }
            }
          }
        }
      })
    case UPDATE_BOOKING_VARIABLE_FAILURE:
      return update(state, {
        updateBookingVariable: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        },
        bookingVariables: {
          results: {
            $apply: items => updateItem(items, action.data)
          }
        }
      })
    case CLEAR_UPDATE_BOOKING_VARIABLE:
      return update(state, {
        updateBookingVariable: { $set: initialState.updateBookingVariable }
      })

    // Get booking variable options
    case GET_BOOKING_VARIABLE_OPTIONS:
      return update(state, {
        bookingVariableOptions: {
          $merge: {
            ...(action.loadOptions.shouldClearExistingState && INITIAL_GET_RESULTS_PAGING_REDUCER),
            isLoading: true
          }
        }
      })
    case GET_BOOKING_VARIABLE_OPTIONS_SUCCESS:
      return update(state, {
        bookingVariableOptions: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            paging: {
              next: action.data?.next
            }
          },
          results: { $push: action.data.results }
        }
      })
    case GET_BOOKING_VARIABLE_OPTIONS_FAILURE:
      return update(state, {
        bookingVariableOptions: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_BOOKING_VARIABLE_OPTIONS:
      return update(state, {
        bookingVariableOptions: { $set: initialState.bookingVariableOptions }
      })

    // Generate campaign reach report
    case GENERATE_CAMPAIGN_REACH_REPORT:
      return update(state, {
        generateCampaignReachReport: { $merge: { isLoading: true } }
      })
    case GENERATE_CAMPAIGN_REACH_REPORT_SUCCESS:
      return update(state, {
        generateCampaignReachReport: {
          $merge: {
            isLoading: false,
            wasCreated: true,
            data: action.data
          }
        }
      })
    case GENERATE_CAMPAIGN_REACH_REPORT_FAILURE:
      return update(state, {
        generateCampaignReachReport: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GENERATE_CAMPAIGN_REACH_REPORT:
      return update(state, {
        generateCampaignReachReport: { $set: initialState.generateCampaignReachReport }
      })

    // Send campaign reach report
    case SEND_CAMPAIGN_REACH_REPORT:
      return update(state, {
        sendCampaignReachReport: { $merge: { isLoading: true } }
      })
    case SEND_CAMPAIGN_REACH_REPORT_SUCCESS:
      return update(state, {
        sendCampaignReachReport: {
          $merge: {
            isLoading: false,
            wasSend: true,
            data: action.data
          }
        }
      })
    case SEND_CAMPAIGN_REACH_REPORT_FAILURE:
      return update(state, {
        sendCampaignReachReport: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_SEND_CAMPAIGN_REACH_REPORT:
      return update(state, {
        sendCampaignReachReport: { $set: initialState.sendCampaignReachReport }
      })

    // Get media order requested files
    case GET_MEDIA_ORDER_REQUESTED_FILES:
      return update(state, {
        mediaOrderRequestedFiles: { $merge: { isLoading: true } }
      })
    case GET_MEDIA_ORDER_REQUESTED_FILES_SUCCESS:
      const bookedMediaMap = new Map(action.data?.booked_medias?.map(media => [media.id, media])) || []

      return update(state, {
        mediaOrderRequestedFiles: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            // for optimisation purpose BE returns object with 2 fields: booked_medias, requested_files instead of array of files
            // that is because one booked media could be in multiple requested_files, so BE avoid duplication
            // for easier data manipulation we make the structure flat and populate each requested_file with the booked_media data
            // additionally the ID is generated based on the requested_file and booked_media id
            results: action.data?.requested_files.map(file => {
              const requestedFile = file.requested_file
              const bookedMediaData = bookedMediaMap.get(requestedFile.booked_media_id)

              return {
                id: `${requestedFile.booked_media_id}-${requestedFile.id}-${requestedFile.date_start}`,
                booked_media: bookedMediaData,
                ...file
              }
            })
          }
        }
      })
    case GET_MEDIA_ORDER_REQUESTED_FILES_FAILURE:
      return update(state, {
        mediaOrderRequestedFiles: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_MEDIA_ORDER_REQUESTED_FILES:
      return update(state, {
        mediaOrderRequestedFiles: { $set: initialState.mediaOrderRequestedFiles }
      })

    default:
      return state
  }
}
